import { Component, input } from '@angular/core';
import * as fromSeriousSystem from '@serious-system';
import * as fromAssistantIcon from './assistants.icon.helper';

@Component({
  selector: 'squadbox-assistant-logo',
  standalone: true,
  imports: [
    fromSeriousSystem.UseAssistantCustomIconDirective,
    fromSeriousSystem.UseAssistantIconDirective,
    fromSeriousSystem.UseAiIconDirective,
  ],
  template: `
    @switch (fromAssistantIcon.getLogoType(logo())) {
      @case ('assistant') {
        <svg
          [sdUseAssistantIcon]="fromAssistantIcon.getAssistantIcon(logo())"
        ></svg>
      }
      @case ('custom') {
        <svg
          [sdUseAssistantCustomIcon]="
            fromAssistantIcon.getAssistantCustomIcon(logo())
          "
        ></svg>
      }
      @case ('ai') {
        <svg [sdUseAiIcon]="fromAssistantIcon.getAssistantAiIcon(logo())"></svg>
      }
      @default {
        <img [src]="logo()" alt="Assistant Logo" />
      }
    }
  `,
})
export class AssistantLogoComponent {
  public readonly logo = input.required<string>();
  protected readonly fromAssistantIcon = fromAssistantIcon;
}
